<template>
    <div>
        <NavBar/>
        <GroupManagement/>
    </div>
</template>

<script>

    import NavBar from '../components/NavBar.vue';
    import GroupManagement from '../components/GroupManagement.vue';

    export default {
        name: 'GerenciarGrupos',
        components: {
            NavBar, 
            GroupManagement
        }
    }

</script>